import { Injectable } from '@angular/core';
import { STORAGE_CONST } from '@app/core/constants/storage-constants';
import { LoginFor, User } from '@app/shared/models/User';
import { EmailAccount } from '@shared/models/mail-accounts';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class AccountsService {
  accountStateChanged: BehaviorSubject<[string, boolean]> = new BehaviorSubject(['', false]);

  redirectedAccount: BehaviorSubject<boolean> = new BehaviorSubject(undefined);

  constructor(private storageSvc: StorageService) {}

  async setEmailAccount(id: string, service: string, user: any, expires = null) {
    await this.storageSvc.setJson(STORAGE_CONST.EMAIL_ACCOUNT(service, id), {
      service,
      id,
      user,
      expires,
    });
  }

  async getEmailAccounts(): Promise<EmailAccount[]> {
    const keys = (await this.storageSvc.keys()).filter((key) =>
      key.startsWith(STORAGE_CONST.email)
    );
    return await Promise.all(
      keys.map(async (key) => {
        const data: EmailAccount = await this.storageSvc.getJson(key);
        return data;
      })
    );
  }

  async getGoogleDriveAccount(): Promise<any> {
    let user;
    const keys = (await this.storageSvc.keys()).filter((key) => key.startsWith(LoginFor.gDrive));
    if (keys.length > 0) {
      user = await this.storageSvc.getJson(keys[0]);
      if (user) {
        return user;
      }
    }
    return null;
  }

  async getOneDriveAccount(): Promise<User> {
    let user;
    const keys = (await this.storageSvc.keys()).filter((key) =>
      key.startsWith(STORAGE_CONST.ONE_DRIVE)
    );
    // const test = await this.storageSvc.keys();
    // test.forEach((key) => {
    // });
    if (keys.length > 0) {
      user = await this.storageSvc.get(keys[0]);
      if (user) {
        return user;
      }
    }
    return null;
  }

  async getOffice365Account(): Promise<User> {
    let user;
    const keys = (await this.storageSvc.keys()).filter((key) =>
      key.trim().startsWith(STORAGE_CONST.OFFICE_365)
    );
    if (keys.length > 0) {
      user = await this.storageSvc.get(keys[0]);
      if (user) {
        return user;
      }
    }
    return null;
  }

  async getBoxAccount(): Promise<User> {
    let user;
    const keys = (await this.storageSvc.keys()).filter((key) => key.startsWith(STORAGE_CONST.BOX));
    if (keys.length > 0) {
      user = await this.storageSvc.getJson(keys[0]);
      if (user) {
        return user;
      }
    }
    return null;
  }

  async getDropBoxAccount(): Promise<User> {
    let user;
    const keys = (await this.storageSvc.keys()).filter((key) =>
      key.startsWith(STORAGE_CONST.DROP_BOX)
    );
    if (keys.length > 0) {
      user = await this.storageSvc.getJson(keys[0]);
      if (user) {
        return user;
      }
    }
    return null;
  }

  async deleteAccount(service: string, id: string) {
    await this.storageSvc.remove(STORAGE_CONST.EMAIL_ACCOUNT(service, id));
  }

  async removeAccount(title) {
    const keys = (await this.storageSvc.keys()).filter((key) => key.startsWith(title));
    if (keys.length > 0) {
      for (let i = 0; i < keys.length; i++) {
        await this.storageSvc.remove(keys[i]);
      }
    }
  }
}
